import React from "react";

const FinalRecommendation = ({ pfrFormData, setPfrFormData }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPfrFormData("finalRecommendation", {
      [name]: value,
    });
  };

  return (
    <>
      <div className="form-section">
        <h3>Analysis of Proposal (Final Recommendations)</h3>
        <div className="form-group">
          <label className="required">Recommendation</label>
          <textarea
            typeof="text"
            name="recommendation"
            value={pfrFormData.finalRecommendation.recommendation}
            onChange={handleInputChange}
            placeholder="Enter Recommendation"
            required
            style={{ minHeight: "150px" }}
          />
        </div>
      </div>
    </>
  );
};

export default FinalRecommendation;
